import React, { useContext, useEffect, useState } from "react";
import Slider from 'react-slick';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import "react-inner-image-zoom/lib/InnerImageZoom/styles.css";
import InnerImageZoom from "react-inner-image-zoom";
import { TbTruckDelivery } from "react-icons/tb";
import { GoGift } from "react-icons/go";
import { MdOutlineSecurity } from "react-icons/md";
import { Offers } from "../sections/Offers";
import { useNavigate, useParams } from "react-router-dom";
import { getProducto, getImagesByProductoId } from '../../actions/home';
import { StockStatus } from "../components/StockStatus";
import { BreadCrumb } from "../components/BreadCrumb";
import { BenefitsSlide } from "../components/BenefitsSlide";
import { CartContext } from "../../contexts/CartContext";
import { Benefits } from "../sections/Benefits";
import { formatPrice } from "../../utils/formatPrice";
import Swal from 'sweetalert2'


export const DetalleProducto = () => {
  const { sku } = useParams();
  const [activeTab, setActiveTab] = useState('Descripcion');
  const [producto, setProducto] = useState(null);
  const [cantidad, setCantidad] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [recomendaciones, setRecomendaciones] = useState([]);
  const [imagenes, setImagenes] = useState([]);
  const { addToCart } = useContext(CartContext);
  const [thumbnailPosition, setThumbnailPosition] = useState("right");
  // const [imagenActual, setImagenActual] = useState(null);
  const navigate = useNavigate();

  const handleClickCarro = () => {
    navigate('/carro-compras');
  };

  const benefitsData = [
    {
      icon: <TbTruckDelivery size={40} className="icon-benefit" />,
      title: 'ENVÍOS A TODO EL PERÚ',
      description: 'Hasta la puerta de tu casa',
    },
    {
      icon: <GoGift size={35} className="icon-benefit" />,
      title: 'PROMOCIONES Y DESCUENTOS',
      description: 'Exclusivo para nuestros suscriptores',
    },
    {
      icon: <MdOutlineSecurity size={35} className="icon-benefit" />,
      title: 'SEGURIDAD Y GARANTÍA',
      description: 'Todos nuestros productos son nuevos y con garantía',
    },
  ];

  const settings = {
    dots: false,
    infinite: true,
    arrows: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 5,
          infinite: true,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          infinite: true,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          initialSlide: 1,
          arrows: true,
        },
      },
      {
        breakpoint: 393,
        settings: {
          slidesToShow: 1,
          initialSlide: 1,
          arrows: true,
        },
      },
      {
        breakpoint: 375,
        settings: {
          slidesToShow: 1,
          infinite: true,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 360,
        settings: {
          slidesToShow: 1,
          infinite: true,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 320,
        settings: {
          slidesToShow: 1,
          infinite: true,
          dots: false,
          arrows: true,
        },
      }
    ],
  };

  // Manejo de la posición de las miniaturas
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1000) {
        setThumbnailPosition("bottom");
      } else {
        setThumbnailPosition("right");
      }
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const loadProduct = async () => {
      try {
        const result = await getProducto(sku);
        console.log('Producto cargado:', result);

        setProducto(result);

        const productoId = result.productoId;

        const images = await getImagesByProductoId(productoId);
        // console.log('Imágenes recibidas:', images);
        const imageItems = images.map((img) => ({
          original: process.env.REACT_APP_URL_MINIO+result.productoImgUrlPrincipal,
          thumbnail: process.env.REACT_APP_URL_MINIO+img.productoImagenImgUrl,
          description: result.productoDescripcion || '',
        }));
        setImagenes(imageItems);


        const complementarios = []
        if (result.productoComplementario1) {
          complementarios.push(result.productoComplementario1)
        }
        if (result.productoComplementario2) {
          complementarios.push(result.productoComplementario2)
        }
        console.log('Complementarios extraídos:', complementarios);
        setRecomendaciones(complementarios);

      } catch (error) {
        console.error('Error al cargar el producto:', error);
        setError(error.message || 'Error al cargar el producto.');
      } finally {
        setLoading(false);
      }
    };

    loadProduct();
  }, [sku]);

  useEffect(() => {
    if (!producto || !producto.productoId) return;
    const fetchImages = async () => {
      try {
        const imgs = await getImagesByProductoId(producto.productoId);
        const imagenesFiltradas = imgs.filter(
          (img) => img.productoImagenImgUrl !== producto.productoImgUrlPrincipal
        );
        const imagenesFormateadas = [
          {
            original: process.env.REACT_APP_URL_MINIO+ producto.productoImgUrlPrincipal,
            thumbnail: process.env.REACT_APP_URL_MINIO+ producto.productoImgUrlPrincipal
          },
          ...imagenesFiltradas.map((img) => ({
            original: process.env.REACT_APP_URL_MINIO+img.productoImagenImgUrl,
            thumbnail: process.env.REACT_APP_URL_MINIO+img.productoImagenImgUrl,
          }))
        ];
        setImagenes(imagenesFormateadas);
      } catch (error) {
        console.error("Error al obtener imágenes:", error);
      }
    };

    fetchImages();
  }, [producto]);


  if (loading) return <div>Cargando...</div>;
  if (error) return <div>Error: {error}</div>;
  if (!producto) return <div>No se encontró el producto.</div>;
  const addCarrito = (producto) => {
    Swal.fire({
      position: "center",
      icon: "success",
      title: "Se agregó al carrito de compras",
      showConfirmButton: false,
      timer: 2500,
      customClass: {
        container: 'custom-body'
      }
    });

    const productoCantidad = { ...producto, cantidad }
    console.log('agregar', productoCantidad)
    addToCart(productoCantidad)
  }
  return (
    <>
      <div className="overflow-x ">
        <div className="font-family-montserrat font16 container-detalle-producto ">
          {/* Barra de navegación */}
          <div className="breadcrumb ">
            <BreadCrumb
              productoNombre={producto.productoNombre}
              categoriaDescripcion={producto.categoria.categoriaDescripcion}
              categoriaCodigo={producto.categoria.categoriaCodigo}
            />
          </div>

          {/* Detalles del producto */}
          <div className="flex-container-wrap bottom-container container-content">
            <div className="container-40xs">
              <div className="container-gallery">

                {imagenes.length > 0 && (
                  <ImageGallery
                    items={imagenes} // Usar el estado de imágenes
                    slideInterval={2000} // Intervalo de tiempo entre slides
                    slideDuration={450} // Duración de la transición entre slides
                    thumbnailPosition={thumbnailPosition} // Usar el estado para la posición de las miniaturas
                    showThumbnails={true}
                    showNav={false}
                    slideOnThumbnailOver={true} // Deslizar al pasar el mouse sobre miniaturas
                    useWindowKeyDown={true}
                    infinite={false} // No permitir el deslizar infinito
                    showPlayButton={false} // No mostrar el botón de reproducción
                    showFullscreenButton={false} // No mostrar el botón de pantalla completa
                    showBullets={false} // No mostrar los bullets
                    showIndex={false} // No mostrar el índice
                    thumbnailHeight={5} // Ajusta el tamaño de las miniaturas
                    thumbnailWidth={5} // Ajusta el tamaño de las miniaturas
                    renderItem={(item) => (
                      <div className="image-zoom-container">
                        <InnerImageZoom
                          src={item.original}
                          zoomSrc={item.original}
                          alt={item.description}
                          zoomType="hover"
                          hideHint={true} // Desactiva el botón de lupa
                        />
                      </div>
                    )}
                  />
                )}

              </div>
            </div>
            <div className="container-60 font-family-montserrat">
              <h5 className="font400 font10">
                <span className="mr-20">
                  {producto.marca ? producto.marca.marcaDescripcion.toUpperCase() : 'MARCA NO DISPONIBLE'}
                </span>
                {' | '}
                <span className="ml-20">SKU: {producto.productoSku}</span>
              </h5>
              <div className="font-family-montserrat font13 btn-ahorro pbuttonoffers width-offers-detail text-center">
                Ahorras {producto.productoDescuentoPorcentaje}%
              </div>
              <h1 className="font25">{producto.productoNombre}</h1>
              <p className="colorF9000 font25 txt-negrita500 pad-precio-detalle">
                {formatPrice(producto.productoPrecio)}
                <s className="colornegro font16v2">
                  {formatPrice(producto.productoPrecioAnterior)}
                </s>
              </p>
              <StockStatus stock={Number(producto.productoStockActual)} claseAdicional="product-status-detalle" />

              <div className="progress-bar">
                <div className="progress"></div>
              </div>

              <div>
                <div className="hr"></div>
              </div>

              <div className="margin-kit">
                <div>
                  <label className="font-family-montserrat font13 font-italic font500 txt-nombre-kit" style={{ paddingBottom: '20px' }} >
                    Arma el kit perfecto con estos productos
                  </label>
                </div>

                {/* Recomendaciones de productos */}
                {recomendaciones.length > 0 && (
                  <div className="container-100 flex-container-wrap flex-wrap-kit container-kit margin-t-b-detalle-producto">

                    {recomendaciones.map((recomendado, index) => (
                      <div key={index} className="tarjeta-kit  flex-container container-48 container-100 borderE2E2E2 border-radius-9 flex-column">
                        <div className="flex-container container-100 container-producto-kit">
                          <div className="container-40 flex-container flex-center">
                            <div>
                              <img
                                src={process.env.REACT_APP_URL_MINIO+recomendado.productoImgUrlPrincipal}
                                alt={recomendado.productoNombre}
                                className="img-responsive width-detalle"
                              />
                            </div>
                            {/* pad-1rem */}
                          </div>
                          <div className="container-60 container-100 align-center flex-container">
                            <div className="container-100 font13 txt-nombre-kit mrg-topauto">
                              <div>
                                {recomendado.productoNombre}
                              </div>
                              <div className="flex-container font-family-montserrat font400 pd-precios-detalle baseline-items">
                                <div className="font13 margin-right-10 colorF9000 txt-nombre-kit">
                                  {formatPrice(producto.productoPrecio)}
                                </div>
                                <div className="flex-center font11 txt-precio-kit" style={{ margin: '0' }}>
                                  {formatPrice(producto.productoPrecioAnterior)}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="flex-container align-center gap-8 font13 txt-nombre-kit">
                          <input type="checkbox" className="custom-checkbox" /> Seleccionar
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div className="container-btn-detalle-producto">
                <div className="font16" style={{ padding: '24px 0' }}>
                  Cantidad
                </div>
                {/* Botones de cantidad y añadir al carrito */}
                <div div className="flex-container container-100" >
                  <div className="width-20-product mbxs-20">
                    <div className="container-100 flex-container">
                      <input
                        type="button"
                        className="height-btndetalle font-inpt-btndetalle font400 pointer btn-counter font-family-montserrat brd-btn-left "
                        value="-"
                        onClick={() => (cantidad > 1) ? setCantidad(cantidad - 1) : 1}
                      />
                      <input
                        type="button"
                        className="height-btndetalle font-inpt-btndetalle font400 pointer btn-counter font-family-montserrat"
                        value={cantidad}
                      />
                      <input
                        type="button"
                        className="height-btndetalle font-inpt-btndetalle font-btndetalle font400 pointer btn-counter font-family-montserrat brd-btn-right"
                        // onClick={() => (cantidad < 10) ? setCantidad(cantidad + 1) : 10}
                        onClick={() =>
                          cantidad < Number(producto.productoStockActual)
                            ? setCantidad(cantidad + 1)
                            : Number(producto.productoStockActual)
                        }
                        value="+"
                      />
                    </div>
                  </div>
                  <div className="width-80-product">
                    <div
                      className="btn-detalle font-btndetalle height-btndetalle font-family-montserrat btn-cart-product pointer container-100 font17"
                      onClick={() => addCarrito(producto)}>
                      Añadir al carrito
                    </div>
                  </div>
                </div>
                <div className="mgt15 margin-top-10">
                  <div
                    onClick={handleClickCarro}
                    className="btn-detalle font-btndetalle height-btndetalle font-family-montserrat btn-cart-product pointer container-100 font17 ">
                    Comprar ahora
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Tabs */}
          <div className="tab">
            <button
              id="tablink-descripcion"
              className={`${activeTab === 'Descripcion' ? 'active' : ''}`}
              onClick={() => setActiveTab('Descripcion')}
            >
              Descripción
            </button>
            <button
              id="tablink-fichatecnica"
              className={`${activeTab === 'Especificaciones' ? 'active' : ''}`}
              onClick={() => setActiveTab('Especificaciones')}
            >
              Especificaciones
            </button>
          </div>
          <div className="ml-10 mr-10 overflow-x">
            <div className={`tabcontent ${activeTab === 'Descripcion' ? 'active' : ''}`}>
              <p style={{ marginBottom: '1em', fontSize: '1.2em', fontWeight: 500 }}>Características:</p>
              <ul>
                {producto.productoEspecificaciones && producto.productoEspecificaciones.length > 0 ? (
                  producto.productoEspecificaciones.map((spec, index) => (
                    <li key={index}>{spec}</li>
                  ))
                ) : (
                  <li>No hay especificaciones disponibles</li>
                )}
              </ul>
            </div>
          </div>

          <div className={`tabcontent ${activeTab === 'Especificaciones' ? 'active' : ''}`}>
            <div className="table">
              <div className="table_header">
                <div className="color-blanco txt-semibold">Especificaciones</div>
              </div>

              <div className="table_content table_content--two-column">
                <div>
                  <div className="link">ID</div>
                  <div className="link">1576</div>
                </div>

                <div>
                  <div className="link">ID</div>
                  <div className="link">1576</div>
                </div>
              </div>
            </div>
          </div>
          <div className="container-slider-benefits">
            <div className="sliderxs">
              <Slider {...settings} className="slider-benefits  background-f5f5f5">
                {benefitsData.map((benefit, index) => (
                  <div key={index}>
                    <BenefitsSlide benefit={benefit} />
                  </div>
                ))}
              </Slider>
            </div>
            <div className="slidersm">
              <Benefits />
            </div>
          </div>
        </div>

        {/* Sección de ofertas */}
        <div className="mrg-b3em">
          <div className="pad-title font-family-montserrat font16 txt-semibold txtitle-interesar">
            Esto te va a interesar
          </div>
          <Offers showButton={true} />
        </div>

      </div>
    </>
  );
};